<template>
  <div
    v-if="modalIsOpened"
    class="fixed inset-0 w-full bg-black/30 z-50"
    @click.self="closeModal"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8 modal-overscroll"
    >
      <div class="w-[100vw] max-w-[1000px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <header class="w-full rounded-t-[10px] py-3 pl-5 pr-2.5 bg-primary">
            <div class="w-full flex justify-between items-center">
              <span class="PC_Body2-R text-[#FCFCFC]">
                ประวัติการอัปเดตข้อมูล
              </span>
              <CloseIcon
                @click="closeModal"
                class="w-6 h-6 text-primary bg-white rounded-full cursor-pointer"
              />
            </div>
          </header>
          <section class="p-[20px]">
            <!-- filter -->
            <div class="w-full flex flex-col gap-[10px] mb-[10px]">
              <div class="w-ful">
                <SearchBox
                  v-model="filter.search"
                  @update:modelValue="
                    () => {
                      (filter.page = ''), debouncedFetch();
                    }
                  "
                  :placeholder="'ค้นหา ชื่อผู้กระทำ'"
                />
              </div>
              <div
                class="flex items-center gap-[10px] flex-wrap sm:flex-nowrap"
              >
                <!-- datePicker -->
                <DatePicker2
                  :containerClass="'w-full sm:max-w-[257px]'"
                  :modelValue="range"
                  :placeholder="'เลือกช่วงเวลาที่กระทำ'"
                  :isRange="true"
                  @update:modelValue="(date) => selectRange(date)"
                />
                <!-- datePicker -->
                <SelectBoxComponent
                  :selectContainerClass="'w-full sm:max-w-[173px]'"
                  :inputId="'damagedUtilitiesOption'"
                  :isFilter="true"
                  :keyValue="'id'"
                  :keyName="'name'"
                  :options="damagedUtilities"
                  :value="filter.type"
                  :placeholder="'แสดงทุกประเภทสถานที่'"
                  @update:modelValue="
                    (res) => {
                      filter.type = res;
                      filter.page = '';
                      getData();
                    }
                  "
                />
                <SelectBoxComponent
                  :selectContainerClass="'w-full sm:max-w-[173px]'"
                  :inputId="'actionStatusOption'"
                  :isFilter="true"
                  :keyValue="'id'"
                  :keyName="'name'"
                  :options="actionStatus"
                  :value="filter.status"
                  :placeholder="'แสดงทุกการกระทำ'"
                  @update:modelValue="
                    (res) => {
                      filter.status = res;
                      filter.page = '';
                      getData();
                    }
                  "
                />
              </div>
            </div>
            <!-- filter -->
            <div class="w-full flex flex-col gap-[20px]">
              <!-- table -->
              <div class="w-full overflow-auto">
                <table class="min-w-[850px]">
                  <thead>
                    <tr>
                      <th
                        class="h-[53px] min-w-[100px] overflow-hidden p-[10px] bg-[#9B237B] text-[#FFFFFF] text-left rounded-l-[4px] border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> วันที่กระทำ </span>
                      </th>
                      <th
                        class="h-[53px] min-w-[54px] overflow-hidden p-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> เวลา </span>
                      </th>
                      <th
                        class="h-[53px] w-[145px] overflow-hidden p-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> ประเภท </span>
                      </th>
                      <th
                        class="h-[53px] w-[462px] overflow-hidden p-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> การกระทำ </span>
                      </th>
                      <th
                        class="h-[53px] w-[200px] overflow-hidden p-[10px] bg-[#9B237B] text-[#FFFFFF] text-left rounded-r-[4px] border-r-[1px] border-solid border-[#FFFFFF]"
                      >
                        <span class="PC_Body2-R"> ชื่อผู้กระทำ </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(row, rowIndex) in damagedUnitInfos"
                      :key="rowIndex"
                      :class="[
                        '!border-none',
                        { 'bg-[#FBEFF8]': (rowIndex + 1) % 2 === 0 },
                      ]"
                    >
                      <td class="w-[100px] p-[10px] !border-none text-center">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ $formatDate2(row.created_at) }}
                        </span>
                      </td>
                      <td class="w-[54px] p-[10px] !border-none truncate">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ $formatTime1(row.created_at) }}
                        </span>
                      </td>
                      <td class="w-[145px] p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ row.datail.type_name }}
                        </span>
                      </td>
                      <td class="w-[462px] p-[10px] !border-none">
                        <span class="PC_Body2-R text-[#1F1D1F]">
                          {{ row.datail.datail }}
                        </span>
                      </td>
                      <td class="w-[200px] p-[10px] !border-none">
                        <div class="flex items-center gap-[10px]">
                          <span class="PC_Body2-R text-[#1F1D1F]">
                            {{ row.created_name }}
                          </span>
                        </div>
                      </td>
                    </tr>
                    <NoInfoYetComponent
                      v-if="damagedUnitInfos.length <= 0"
                      :col="'10'"
                      :icon="'DisasterIcon2'"
                    />
                  </tbody>
                </table>
              </div>
              <!-- table -->
              <!-- pagination -->
              <PaginationComponent
                :perPageId="'perpagemodal1'"
                :items="paginationInfo"
                @selectedPage="handlePage"
              />
              <!-- pagination -->
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import axios from "axios";
import { debounce } from "lodash";

const { $formatDate3 } = useGlobals();
const modalIsOpened = ref(false);
const paginationInfo = ref({});
const errors = ref({});
const range = ref(null);
const filter = ref({
  paginate: 10,
  page: "",
  search: "",
  data: "",
  start_date: "",
  end_date: "",
  type: "",
  status: "",
});

const actionStatus = [
  {
    id: "",
    name: "แสดงทุกประเภทสถานที่",
  },
  {
    id: 1,
    name: "เพิ่มสถานที่",
  },
  {
    id: 2,
    name: "แก้ไขสถานที่",
  },
  {
    id: 3,
    name: "ลบสถานที่",
  },
];

const damagedUnitInfos = ref([]);
const damagedUtilities = ref([]);

const data = ref({});

const handlePage = (page, perpage) => {
  filter.value.page = page;
  filter.value.paginate = perpage;
  getData();
};

const getData = () => {
  axios
    .get("/damaged-utility-logs/", { params: filter.value })
    .then((res) => {
      if (res.data.code == 200) {
        paginationInfo.value = res.data.data;
        damagedUnitInfos.value = res.data.data.data;
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
const openModal = (damagedUtils) => {
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.width = "100%";
  filter.value.search = "";
  let damagedUtilities_first = {
    id: "",
    name: "แสดงทุกการกระทำ",
  };
  damagedUtilities.value = [damagedUtilities_first, ...damagedUtils];
  axios
    .get("/damaged-utility-logs/", { params: filter.value })
    .then((res) => {
      if (res.data.code == 200) {
        paginationInfo.value = res.data.data;
        damagedUnitInfos.value = res.data.data.data;
      }
    })
    .catch((err) => {
      console.log(err);
    });
  modalIsOpened.value = true;
};

const closeModal = () => {
  document.body.style.overflow = "";
  document.body.style.position = "";
  document.body.style.width = "";
  filter.value.search = "";
  filter.value.date = "";
  filter.value.start_date = "";
  filter.value.end_date = "";
  filter.value.type = "";
  filter.value.status = "";

  damagedUnitInfos.value = [];
  modalIsOpened.value = false;
};
const debouncedFetch = debounce(getData, 300);

// const changeDate = (res) => {
//   if (res == null) {
//     filter.value.date = "";
//     filter.value.start_date = "";
//     filter.value.end_date = "";
//   } else {
//     filter.value.date = res;
//     if (res.length == 2) {
//       filter.value.start_date = res[0];
//       filter.value.end_date = res[1];
//     }
//   }
//   filter.value.page = 1;
//   getData();
// };

const selectRange = (date) => {
  filter.value.page = "";
  range.value = date;
  if (date != null) {
    filter.value.start_date = $formatDate3(date[0]);
    filter.value.end_date = $formatDate3(date[1]);
  } else {
    filter.value.start_date = "";
    filter.value.end_date = "";
  }
  getData();
};

// const getStatusName = (id) => {
//   const found = actionStatus.find(item => item.id === id);
//   return found ? found.name : "ไม่พบสถานะ";
// };

defineExpose({
  openModal,
  closeModal,
});
</script>
